// @flow

import {
  CHANGE_PASSWORD_RESET, CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE
} from '../actions/account'
import { LOGOUT_USER } from '../actions/auth'

type State = {
  isChangingPassword: boolean,
  statusText: ?string,
  changePasswordErrorMessage: ?string,
  changePasswordSuccessMessage: ?string
}

const initialState: State = {
  isChangingPassword: false,
  wasPasswordChanged: false,
  statusText: null,
  changePasswordErrorMessage: null,
  changePasswordSuccessMessage: null
}

export function account (state: State = initialState, action: Object) : Object {
  switch (action.type) {

    case CHANGE_PASSWORD_RESET:
      return Object.assign({}, state, initialState)

    case CHANGE_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isChangingPassword: true,
        wasPasswordChanged: null,
        changePasswordErrorMessage: null,
        changePasswordSuccessMessage: null
      })

    case CHANGE_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        isChangingPassword: false,
        wasPasswordChanged: true,
        changePasswordErrorMessage: null,
        changePasswordSuccessMessage: 'You updated your password.'
      })

    case CHANGE_PASSWORD_FAILURE:
      return Object.assign({}, state, {
        isChangingPassword: false,
        wasPasswordChanged: false,
        changePasswordSuccessMessage: null,
        changePasswordErrorMessage: 'Current password is incorrect.'
      })

    case LOGOUT_USER:
      return Object.assign({}, state, initialState)

    default:
      return state
  }
}
